'use strict';
import $ = require('jquery');

export class Parts {
    public static stopBodyScroll() {
        $('body').css('height', window.visualViewport.height).css('overflow', 'clip');
    }

    public static startBodyScroll() {
        $('body').css('height', 'auto').css('overflow', 'revert');
    }
    public static media() {
        let isPC = window.innerWidth > 768;
        window.matchMedia('(min-width: 768px)').addEventListener('change', (e) => {
            isPC = e.matches;
        });
    }
}

export default Parts;